const header = document.querySelector("[data-header]");
const menuToggle = document.querySelector("[data-menu-toggle]");
const nav = document.querySelector("[data-nav]");
const rail = document.querySelector("[data-product-rail]");
const driftTitles = Array.from(document.querySelectorAll("[data-drift-title]"));
const scrollBoundTitles = driftTitles.filter((title) => title.classList.contains("section-title"));
const allowDriftMotion = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const driftTitleState = new WeakMap();
let previousScrollY = window.scrollY;
let previousScrollTime = performance.now();
let activeVideoTrigger = null;

const syncHeroEntranceLogoTarget = () => {
  const entrance = document.querySelector(".hero-entrance");
  const mark = document.querySelector(".hero-entrance__mark");
  const brandLogo = document.querySelector("[data-header] .brand img");
  const header = document.querySelector("[data-header]");

  const revealHeaderBrand = () => {
    header?.classList.remove("site-header--intro-pending");
    header?.classList.add("site-header--intro-ready");
  };

  if (!entrance || !mark || !brandLogo || !header) return;

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    revealHeaderBrand();
    return;
  }

  const updateTarget = () => {
    const markRect = mark.getBoundingClientRect();
    const brandRect = brandLogo.getBoundingClientRect();

    if (!markRect.width || !markRect.height || !brandRect.width || !brandRect.height) return;

    const markCenterX = markRect.left + markRect.width / 2;
    const markCenterY = markRect.top + markRect.height / 2;
    const brandCenterX = brandRect.left + brandRect.width / 2;
    const brandCenterY = brandRect.top + brandRect.height / 2;
    const targetScale = brandRect.width / markRect.width;

    entrance.style.setProperty("--loader-logo-shift-x", `${brandCenterX - markCenterX}px`);
    entrance.style.setProperty("--loader-logo-shift-y", `${brandCenterY - markCenterY}px`);
    entrance.style.setProperty("--loader-logo-scale", targetScale.toFixed(4));
  };

  updateTarget();

  // The lockup has its own settle animation before the mark flies to the nav.
  // Re-measure after that settle so the target is based on the stable mark center.
  window.setTimeout(updateTarget, 700);

  if (!mark.complete || !brandLogo.complete) {
    mark.addEventListener("load", updateTarget, { once: true });
    brandLogo.addEventListener("load", updateTarget, { once: true });
  }

  mark.addEventListener("animationend", (event) => {
    if (event.animationName === "heroEntranceMarkFlight") {
      revealHeaderBrand();
    }
  });

  window.setTimeout(revealHeaderBrand, 3400);
  window.addEventListener("resize", updateTarget, { passive: true });
};

syncHeroEntranceLogoTarget();

const initObfuscatedEmails = () => {
  const decode = (value) => (value || "").split("").reverse().join("");

  document.querySelectorAll("[data-email-u][data-email-d][data-email-s]").forEach((node) => {
    const user = decode(node.dataset.emailU);
    const domain = decode(node.dataset.emailD);
    const suffix = decode(node.dataset.emailS);
    if (!user || !domain || !suffix) return;

    const email = `${user}@${domain}${suffix}`;
    const emailHref = `mailto:${email}`;
    const link = document.createElement("a");
    link.href = "#contact-email";
    link.textContent = node.dataset.emailLabel || node.textContent || "Email";
    link.setAttribute("aria-label", node.dataset.emailLabel || "Email contact");
    link.className = node.className;

    const armEmailLink = () => {
      link.href = emailHref;
    };

    link.addEventListener("pointerdown", armEmailLink, { once: true });
    link.addEventListener("touchstart", armEmailLink, { once: true, passive: true });
    link.addEventListener("focus", armEmailLink, { once: true });
    link.addEventListener("click", armEmailLink);
    node.replaceWith(link);
  });
};

initObfuscatedEmails();

const initContactSpamGuard = () => {
  document.querySelectorAll("[data-contact-spam-guard]").forEach((form) => {
    const startedAt = Date.now();

    form.addEventListener("submit", (event) => {
      const trap = form.querySelector("[data-contact-trap]");
      const elapsed = Date.now() - startedAt;

      if (trap?.value.trim() || elapsed < 1800) {
        event.preventDefault();
      }
    });
  });
};

initContactSpamGuard();

const initHeroVideo = () => {
  const video = document.querySelector("[data-hero-video]");
  if (!video?.dataset.heroVideos) return;

  const options = video.dataset.heroVideos
    .split(",")
    .map((entry) => {
      const [src, poster] = entry.split("|");
      return { src, poster };
    })
    .filter((entry) => entry.src);

  if (!options.length) return;

  const randomValue = window.crypto?.getRandomValues
    ? window.crypto.getRandomValues(new Uint32Array(1))[0] / 4294967296
    : Math.random();
  const selected = options[Math.floor(randomValue * options.length)];
  let source = video.querySelector("source");

  if (selected.poster) {
    video.setAttribute("poster", selected.poster);
  }

  if (!source) {
    source = document.createElement("source");
    source.type = "video/mp4";
    video.appendChild(source);
  }

  if (selected.src && source.getAttribute("src") !== selected.src) {
    source.setAttribute("src", selected.src);
    video.load();
  }

  const playPromise = video.play?.();
  if (playPromise?.catch) {
    playPromise.catch(() => {});
  }
};

initHeroVideo();

const loadBandsintownScript = (tourBoard) => {
  const src = tourBoard?.dataset.bandsintownSrc;
  if (!src) return Promise.resolve();

  tourBoard.dataset.bandsintownLoaded = "true";

  if (window.__amsBandsintownPromise) {
    return window.__amsBandsintownPromise.then(normalizeBandsintownButtons);
  }

  const existingScript = document.querySelector(`script[src="${src}"]`);
  if (existingScript) {
    window.__amsBandsintownPromise = Promise.resolve();
    normalizeBandsintownButtons();
    return window.__amsBandsintownPromise;
  }

  window.__amsBandsintownPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.charset = "utf-8";
    script.src = src;
    script.async = true;
    script.onload = () => {
      normalizeBandsintownButtons();
      resolve();
    };
    script.onerror = reject;
    document.head.appendChild(script);
  });

  return window.__amsBandsintownPromise;
};

const initBandsintownLazyLoad = () => {
  const tourBoards = Array.from(document.querySelectorAll("[data-bandsintown-src]"));
  if (!tourBoards.length) return;

  const loadBoard = (tourBoard) => {
    if (tourBoard.dataset.bandsintownLoaded === "true") return;
    loadBandsintownScript(tourBoard).catch(() => {});
  };

  if (!("IntersectionObserver" in window)) {
    tourBoards.forEach(loadBoard);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        loadBoard(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: "500px 0px" }
  );

  tourBoards.forEach((tourBoard) => {
    const bounds = tourBoard.getBoundingClientRect();
    if (bounds.top < window.innerHeight + 500) {
      loadBoard(tourBoard);
      return;
    }
    observer.observe(tourBoard);
  });
};

const normalizeBandsintownButtons = () => {
  const widget = document.querySelector(".tour-board--embed .bit-widget");
  if (!widget) return;

  const selectors = [
    "a[class*='ticket']",
    "button[class*='ticket']",
    "[role='button'][class*='ticket']",
    "a[class*='offer']",
    "button[class*='offer']",
    "[class*='offer']",
    "[role='button'][class*='offer']",
    ".bit-play-my-city-cta",
    ".bit-follow-section-cta"
  ];

  widget.querySelectorAll(selectors.join(",")).forEach((button) => {
    const text = button.textContent?.trim().toLowerCase() || "";
    const classes = `${button.className || ""}`.toLowerCase();
    const isLightCta =
      text.includes("ticket") ||
      text.includes("request a show") ||
      classes.includes("ticket") ||
      classes.includes("offer") ||
      classes.includes("play-my-city") ||
      classes.includes("follow-section-cta");

    if (!isLightCta) return;

    button.style.setProperty("background", "#fff", "important");
    button.style.setProperty("background-color", "#fff", "important");
    button.style.setProperty("border-color", "#fff", "important");
    button.style.setProperty("color", "#090909", "important");
    button.style.setProperty("-webkit-text-fill-color", "#090909", "important");
    button.style.setProperty("text-shadow", "none", "important");

    button.querySelectorAll("*").forEach((child) => {
      child.style.setProperty("color", "#090909", "important");
      child.style.setProperty("-webkit-text-fill-color", "#090909", "important");
      child.style.setProperty("text-shadow", "none", "important");
    });
  });
};

initBandsintownLazyLoad();

const initBandsintownButtonGuard = () => {
  const tourBoard = document.querySelector(".tour-board--embed");
  if (!tourBoard) return;

  normalizeBandsintownButtons();

  const observer = new MutationObserver(normalizeBandsintownButtons);
  observer.observe(tourBoard, {
    childList: true,
    subtree: true
  });

  tourBoard.addEventListener("mouseover", normalizeBandsintownButtons, true);
  tourBoard.addEventListener("focusin", normalizeBandsintownButtons, true);
};

initBandsintownButtonGuard();

const updateHeader = () => {
  header?.classList.toggle("is-scrolled", window.scrollY > 24);
};

updateHeader();
window.addEventListener("scroll", updateHeader, { passive: true });

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
const easeInOut = (value) => {
  const t = clamp(value, 0, 1);
  return t * t * (3 - 2 * t);
};

const updateDriftTitles = () => {
  if (!allowDriftMotion || !driftTitles.length || window.innerWidth < 981) {
    return false;
  }

  const now = performance.now();
  const elapsed = Math.max(16, now - previousScrollTime);
  const scrollVelocity = clamp((window.scrollY - previousScrollY) / elapsed, -2.4, 2.4);
  previousScrollY = window.scrollY;
  previousScrollTime = now;
  let shouldContinue = false;

  driftTitles.forEach((title) => {
    const section = title.closest(".image-section");
    if (!section) return;

    const sectionRect = section.getBoundingClientRect();
    const titleRect = title.getBoundingClientRect();
    const travelWindow = Math.max(1, sectionRect.height - titleRect.height);
    const progress = clamp((window.innerHeight * 0.64 - sectionRect.top) / travelWindow, 0, 1);
    const eased = easeInOut(progress);
    const targetY = (eased - 0.5) * 28;
    const state = driftTitleState.get(title) ?? { y: targetY, velocity: 0 };

    state.velocity += (targetY - state.y) * 0.16;
    state.velocity += clamp(scrollVelocity * 4.6, -8, 8);
    state.velocity *= 0.68;
    state.y = clamp(state.y + state.velocity, -44, 44);

    if (Math.abs(state.velocity) > 0.05 || Math.abs(targetY - state.y) > 0.05) {
      shouldContinue = true;
    }

    driftTitleState.set(title, state);
    title.style.setProperty("--title-drift-x", "0px");
    title.style.setProperty("--title-drift-y", `${state.y.toFixed(2)}px`);
  });

  return shouldContinue;
};

const resetScrollBoundTitle = (title) => {
  title.style.position = "";
  title.style.top = "";
  title.style.left = "";
  title.style.width = "";
};

const updateScrollBoundTitles = () => {
  if (!scrollBoundTitles.length) return;

  scrollBoundTitles.forEach((title) => {
    const section = title.closest(".image-section");
    const layout = title.parentElement;
    if (!section || !layout || window.innerWidth < 981) {
      resetScrollBoundTitle(title);
      return;
    }

    resetScrollBoundTitle(title);

    const sectionRect = section.getBoundingClientRect();
    const layoutRect = layout.getBoundingClientRect();
    const titleHeight = title.offsetHeight;
    const titleWidth = title.offsetWidth;
    const stickyTop = clamp(window.innerHeight * 0.16, 108, 142);
    const releaseTop = sectionRect.bottom - titleHeight - 96;

    if (sectionRect.top > stickyTop || sectionRect.bottom < stickyTop + titleHeight) {
      resetScrollBoundTitle(title);
      return;
    }

    title.style.position = "fixed";
    title.style.top = `${Math.min(stickyTop, releaseTop).toFixed(2)}px`;
    title.style.left = `${layoutRect.left.toFixed(2)}px`;
    title.style.width = `${titleWidth.toFixed(2)}px`;
  });
};

let driftFrame = 0;
const requestDriftUpdate = () => {
  if (driftFrame) return;
  driftFrame = window.requestAnimationFrame(() => {
    driftFrame = 0;
    updateScrollBoundTitles();
    if (updateDriftTitles()) {
      requestDriftUpdate();
    }
  });
};

updateScrollBoundTitles();
updateDriftTitles();
window.addEventListener("scroll", requestDriftUpdate, { passive: true });
window.addEventListener("resize", requestDriftUpdate);

menuToggle?.addEventListener("click", () => {
  const isOpen = nav?.classList.toggle("is-open") ?? false;
  document.body.classList.toggle("nav-open", isOpen);
  menuToggle.classList.toggle("is-open", isOpen);
  menuToggle.setAttribute("aria-expanded", String(isOpen));
});

nav?.addEventListener("click", (event) => {
  if (event.target instanceof HTMLAnchorElement) {
    nav.classList.remove("is-open");
    document.body.classList.remove("nav-open");
    menuToggle?.classList.remove("is-open");
    menuToggle?.setAttribute("aria-expanded", "false");
  }
});

document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape" || !nav?.classList.contains("is-open")) return;
  nav.classList.remove("is-open");
  document.body.classList.remove("nav-open");
  menuToggle?.classList.remove("is-open");
  menuToggle?.setAttribute("aria-expanded", "false");
});

document.querySelector("[data-shop-prev]")?.addEventListener("click", () => {
  rail?.scrollBy({ left: -360, behavior: "smooth" });
});

document.querySelector("[data-shop-next]")?.addEventListener("click", () => {
  rail?.scrollBy({ left: 360, behavior: "smooth" });
});

let cartCache = null;

const escapeHTML = (value = "") => String(value).replace(/[&<>"']/g, (char) => ({
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  "\"": "&quot;",
  "'": "&#39;"
}[char]));

const formatCartMoney = (amount, currency = "USD") => {
  const value = Number(amount || 0) / 100;
  try {
    return new Intl.NumberFormat(document.documentElement.lang || "en", {
      style: "currency",
      currency
    }).format(value);
  } catch (_) {
    return `$${value.toFixed(2)}`;
  }
};

const fetchCart = async ({ force = false } = {}) => {
  if (cartCache && !force) return cartCache;
  const response = await fetch("/cart.js", {
    headers: { Accept: "application/json" }
  });
  if (!response.ok) throw new Error("Could not load cart.");
  cartCache = await response.json();
  return cartCache;
};

const updateCartIndicators = (cart) => {
  document.querySelectorAll("[data-cart-count]").forEach((node) => {
    node.textContent = cart.item_count;
  });
  document.querySelectorAll("[data-cart-count-bubble]").forEach((node) => {
    node.classList.toggle("hide", cart.item_count === 0);
  });
  document.querySelectorAll("[data-mini-cart-trigger]").forEach((node) => {
    const labelItem = cart.item_count === 1 ? "item" : "items";
    node.setAttribute("aria-label", `View cart, ${cart.item_count} ${labelItem}`);
  });
};

const renderMiniCart = (cart) => {
  const currency = cart.currency || window.Shopify?.currency?.active || "USD";
  const items = Array.isArray(cart.items) ? cart.items : [];

  document.querySelectorAll("[data-mini-cart-popover]").forEach((popover) => {
    if (!items.length) {
      popover.innerHTML = '<p class="nav-mini-cart__empty">Your cart is empty.</p>';
      return;
    }

    const visibleItems = items.slice(0, 3);
    const extraCount = Math.max(items.length - visibleItems.length, 0);
    const itemMarkup = visibleItems.map((item) => {
      const image = item.image
        ? `<img src="${escapeHTML(item.image)}" alt="">`
        : '<span class="nav-mini-cart__image-fallback" aria-hidden="true"></span>';
      const variant = item.variant_title && item.variant_title !== "Default Title"
        ? `<span>${escapeHTML(item.variant_title)}</span>`
        : "";
      return `
        <div class="nav-mini-cart__item">
          ${image}
          <div>
            <p class="nav-mini-cart__item-title">${escapeHTML(item.product_title || item.title)}</p>
            <p class="nav-mini-cart__item-meta">Qty ${item.quantity}${variant ? ` · ${variant}` : ""}</p>
          </div>
        </div>
      `;
    }).join("");

    popover.innerHTML = `
      <div class="nav-mini-cart__heading">
        <strong>Cart</strong>
        <span>${cart.item_count} ${cart.item_count === 1 ? "item" : "items"}</span>
      </div>
      <div class="nav-mini-cart__items">
        ${itemMarkup}
        ${extraCount ? `<p class="nav-mini-cart__item-meta">+${extraCount} more</p>` : ""}
      </div>
      <div class="nav-mini-cart__total">
        <strong>Subtotal</strong>
        <span>${formatCartMoney(cart.total_price, currency)}</span>
      </div>
      <div class="nav-mini-cart__actions">
        <a href="/cart">View cart</a>
        <a href="/checkout">Checkout</a>
      </div>
    `;
  });
};

const refreshCartUi = async ({ force = false } = {}) => {
  try {
    const cart = await fetchCart({ force });
    updateCartIndicators(cart);
    renderMiniCart(cart);
  } catch (_) {
    document.querySelectorAll("[data-mini-cart-popover]").forEach((popover) => {
      popover.innerHTML = '<p class="nav-mini-cart__empty">Cart details could not load.</p>';
    });
  }
};

const initMiniCartPopovers = () => {
  document.querySelectorAll("[data-mini-cart]").forEach((cluster) => {
    const navItem = cluster.closest(".nav-item");
    const trigger = cluster.querySelector("[data-mini-cart-trigger]");
    const popover = cluster.querySelector("[data-mini-cart-popover]");
    if (!trigger || !popover) return;
    const desktopHover = window.matchMedia("(min-width: 981px)");

    const open = () => {
      if (!desktopHover.matches) return;
      navItem?.classList.add("is-cart-open");
      navItem?.classList.remove("is-shop-menu-open");
      refreshCartUi();
    };
    const close = () => navItem?.classList.remove("is-cart-open");

    trigger.addEventListener("mouseenter", open);
    trigger.addEventListener("focus", open);
    popover.addEventListener("mouseenter", open);
    cluster.addEventListener("mouseleave", close);
    cluster.addEventListener("focusout", (event) => {
      if (!cluster.contains(event.relatedTarget)) close();
    });
  });
};

initMiniCartPopovers();

const initShopSubmenus = () => {
  document.querySelectorAll(".nav-item--shop").forEach((navItem) => {
    const shopLink = navItem.querySelector(".nav-shop-text");
    const cartLink = navItem.querySelector(".nav-shop-cart");
    const submenu = navItem.querySelector(".nav-submenu--shop");
    if (!shopLink || !submenu) return;
    const desktopHover = window.matchMedia("(min-width: 981px)");

    let closeTimer;

    const open = () => {
      if (!desktopHover.matches) return;
      window.clearTimeout(closeTimer);
      navItem.classList.add("is-shop-menu-open");
      navItem.classList.remove("is-cart-open");
    };

    const close = () => {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        navItem.classList.remove("is-shop-menu-open");
      }, 160);
    };

    const closeNow = () => {
      window.clearTimeout(closeTimer);
      navItem.classList.remove("is-shop-menu-open");
    };

    shopLink.addEventListener("mouseenter", open);
    shopLink.addEventListener("focus", open);
    shopLink.addEventListener("mouseleave", close);
    submenu.addEventListener("mouseenter", open);
    submenu.addEventListener("mouseleave", close);
    cartLink?.addEventListener("mouseenter", closeNow);

    navItem.addEventListener("focusout", (event) => {
      if (!navItem.contains(event.relatedTarget)) closeNow();
    });
  });
};

initShopSubmenus();

const initHomepageProductCards = () => {
  const cards = Array.from(document.querySelectorAll("[data-ams-product-card]"));
  if (!cards.length) return;

  const updateCardFromVariant = (card) => {
    const variant = card.querySelector("[data-ams-product-card-variant]");
    const selected = variant?.tagName === "SELECT"
      ? variant.options[variant.selectedIndex]
      : variant;
    const button = card.querySelector("[data-ams-product-card-add]");
    const addText = card.querySelector("[data-ams-product-card-add-text]");
    const price = card.querySelector("[data-ams-product-card-price]");
    const image = card.querySelector("[data-ams-product-card-image]");
    const available = selected?.dataset.available === "true";

    if (price && selected?.dataset.price) {
      price.textContent = selected.dataset.price;
    }

    if (image && selected?.dataset.imageSrc) {
      image.src = selected.dataset.imageSrc;
    }

    if (button && addText) {
      button.disabled = !available;
      button.toggleAttribute("aria-disabled", !available);
      addText.textContent = available ? "Add to cart" : "Sold out";
    }
  };

  const setStatus = (form, message) => {
    const status = form.querySelector("[data-ams-product-card-status]");
    if (status) status.textContent = message;
  };

  const updateCartCount = async () => {
    await refreshCartUi({ force: true });
  };

  const closeVariantMenus = (exceptMenu = null) => {
    cards.forEach((card) => {
      card.querySelectorAll("[data-ams-product-card-variant-menu]").forEach((menu) => {
        if (menu === exceptMenu) return;
        menu.classList.remove("is-open");
        menu.querySelector("[data-ams-product-card-variant-trigger]")?.setAttribute("aria-expanded", "false");
      });
    });
  };

  cards.forEach((card) => {
    updateCardFromVariant(card);

    card.addEventListener("change", (event) => {
      if (event.target.matches("[data-ams-product-card-variant]")) {
        updateCardFromVariant(card);
      }
    });

    card.addEventListener("click", (event) => {
      const trigger = event.target.closest("[data-ams-product-card-variant-trigger]");
      if (trigger) {
        const menu = trigger.closest("[data-ams-product-card-variant-menu]");
        const willOpen = !menu?.classList.contains("is-open");
        closeVariantMenus(menu);
        menu?.classList.toggle("is-open", willOpen);
        trigger.setAttribute("aria-expanded", willOpen ? "true" : "false");
        return;
      }

      const option = event.target.closest("[data-ams-product-card-variant-option]");
      if (!option || option.disabled) return;

      const variant = card.querySelector("[data-ams-product-card-variant]");
      if (!variant) return;

      variant.value = option.dataset.variantId || "";
      variant.dataset.price = option.dataset.price || "";
      variant.dataset.available = option.dataset.available || "false";
      if (option.dataset.imageSrc) {
        variant.dataset.imageSrc = option.dataset.imageSrc;
      } else {
        delete variant.dataset.imageSrc;
      }

      card.querySelectorAll("[data-ams-product-card-variant-option]").forEach((button) => {
        const isSelected = button === option;
        button.classList.toggle("is-selected", isSelected);
        button.setAttribute("aria-checked", isSelected ? "true" : "false");
        button.setAttribute("aria-selected", isSelected ? "true" : "false");
      });

      const menu = option.closest("[data-ams-product-card-variant-menu]");
      if (menu) {
        const label = menu.querySelector("[data-ams-product-card-variant-label]");
        const trigger = menu.querySelector("[data-ams-product-card-variant-trigger]");
        if (label) label.textContent = option.dataset.variantTitle || option.textContent.trim();
        menu.classList.remove("is-open");
        trigger?.setAttribute("aria-expanded", "false");
      }

      updateCardFromVariant(card);
    });
  });

  document.addEventListener("click", (event) => {
    if (!event.target.closest("[data-ams-product-card-variant-menu]")) closeVariantMenus();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeVariantMenus();
  });

  document.addEventListener("submit", async (event) => {
    const form = event.target.closest?.("[data-ams-product-card-quick-add]");
    if (!form) return;

    event.preventDefault();
    const button = form.querySelector("[data-ams-product-card-add]");
    const addText = form.querySelector("[data-ams-product-card-add-text]");
    if (button?.disabled) return;

    setStatus(form, "");
    button.disabled = true;
    if (addText) addText.textContent = "Adding...";

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        body: new FormData(form),
        headers: { Accept: "application/json" }
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || "Could not add this item.");
      }

      await updateCartCount();
      setStatus(form, "Added to cart");
      window.setTimeout(() => setStatus(form, ""), 2500);
    } catch (error) {
      setStatus(form, error.message || "Could not add this item.");
    } finally {
      updateCardFromVariant(form.closest("[data-ams-product-card]"));
    }
  });
};

initHomepageProductCards();

const initInlineVideoPlayers = () => {
  const getYouTubeThumbnail = (videoId, quality = "maxresdefault") => `https://i.ytimg.com/vi/${videoId}/${quality}.jpg`;
  const applyThumbnailFallback = (image, videoId) => {
    if (!image || !videoId) return;

    const fallback = image.dataset.videoThumbFallback || getYouTubeThumbnail(videoId, "hqdefault");
    image.dataset.videoThumbFallback = fallback;
    image.onerror = () => {
      if (image.src !== fallback) image.src = fallback;
    };
  };

  document.querySelectorAll("[data-video-player]").forEach((player) => {
    const tabs = Array.from(player.querySelectorAll("[data-video-tab]"));
    const playlists = Array.from(player.querySelectorAll("[data-video-playlist]"));
    const mainButton = player.querySelector("[data-video-main-play]");
    const mainThumb = player.querySelector("[data-video-main-thumb]");
    const mainTitle = player.querySelector("[data-video-main-title]");
    const mainCategory = player.querySelector("[data-video-main-category]");
    const maxPerCategory = Number.parseInt(player.dataset.videoMaxPerCategory || "10", 10);

    if (!mainButton || !mainThumb || !mainTitle || !mainCategory) return;

    player.querySelectorAll("[data-video-card]").forEach((card) => {
      applyThumbnailFallback(card.querySelector("img"), card.dataset.videoId);
    });
    applyThumbnailFallback(mainThumb, mainButton.dataset.videoId);

    const getPlaylistCards = (playlist) => Array.from(playlist?.querySelectorAll("[data-video-card]") || []);
    const refreshPlaylistThumbnails = (playlist, activeCard = null) => {
      let visibleCount = 0;

      getPlaylistCards(playlist).forEach((card) => {
        const isCurrentMain = card === activeCard;
        const reachedLimit = Number.isFinite(maxPerCategory) && maxPerCategory > 0 && visibleCount >= maxPerCategory;
        const shouldHide = isCurrentMain || reachedLimit;

        card.hidden = shouldHide;
        if (!shouldHide) visibleCount += 1;
      });
    };

    const setMainVideo = (card) => {
      const videoId = card?.dataset.videoId;
      if (!videoId) return;

      mainButton.dataset.videoId = videoId;
      mainButton.dataset.videoTitle = card.dataset.videoTitle || card.textContent.trim();
      const cardImage = card.querySelector("img");
      mainThumb.dataset.videoThumbFallback = cardImage?.dataset.videoThumbFallback || getYouTubeThumbnail(videoId, "hqdefault");
      applyThumbnailFallback(mainThumb, videoId);
      mainThumb.src = getYouTubeThumbnail(videoId);
      mainThumb.alt = cardImage?.alt || mainButton.dataset.videoTitle;
      mainTitle.textContent = mainButton.dataset.videoTitle;
      mainCategory.textContent = card.dataset.videoCategory || "";

      player.querySelectorAll("[data-video-card]").forEach((item) => {
        item.classList.toggle("is-active", item === card);
      });

      playlists.forEach((playlist) => {
        const isCardPlaylist = playlist.contains(card);
        refreshPlaylistThumbnails(playlist, isCardPlaylist ? card : null);
      });
    };

    const setActivePlaylist = (category) => {
      player.dataset.videoActive = category;

      tabs.forEach((tab) => {
        const isActive = tab.dataset.videoTab === category;
        tab.classList.toggle("is-active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
      });

      playlists.forEach((playlist) => {
        const isActive = playlist.dataset.videoPlaylist === category;
        playlist.hidden = !isActive;
        playlist.classList.toggle("is-active", isActive);
      });

      const activePlaylist = playlists.find((playlist) => playlist.dataset.videoPlaylist === category);
      setMainVideo(getPlaylistCards(activePlaylist)[0]);
    };

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => setActivePlaylist(tab.dataset.videoTab));
    });

    player.querySelectorAll("[data-video-card]").forEach((card) => {
      card.addEventListener("click", () => {
        setMainVideo(card);
        openVideoModal(card);
      });
    });

    mainButton.addEventListener("click", () => openVideoModal(mainButton));
    setActivePlaylist(player.dataset.videoActive || tabs[0]?.dataset.videoTab);
  });
};

const createVideoModal = () => {
  const modal = document.createElement("div");
  modal.className = "video-modal";
  modal.setAttribute("aria-hidden", "true");
  modal.innerHTML = `
    <div class="video-modal__panel" role="dialog" aria-modal="true" aria-label="Video player">
      <div class="video-modal__frame" data-video-frame></div>
      <h3 class="video-modal__title" data-video-modal-title></h3>
      <button class="video-modal__close" type="button" aria-label="Close video" data-video-close></button>
    </div>
  `;
  document.body.appendChild(modal);
  return modal;
};

const videoModal = createVideoModal();
const videoFrame = videoModal.querySelector("[data-video-frame]");
const videoTitle = videoModal.querySelector("[data-video-modal-title]");
const videoClose = videoModal.querySelector("[data-video-close]");

const closeVideoModal = () => {
  videoModal.classList.remove("is-open");
  videoModal.setAttribute("aria-hidden", "true");
  document.body.style.overflow = "";
  if (videoFrame) {
    videoFrame.innerHTML = "";
  }
  activeVideoTrigger?.focus();
};

const openVideoModal = (trigger) => {
  const videoId = trigger.dataset.videoId;
  if (!videoId || !videoFrame || !videoTitle) return;

  activeVideoTrigger = trigger;
  videoTitle.textContent = trigger.dataset.videoTitle || trigger.textContent.trim();
  videoFrame.innerHTML = `
    <iframe
      src="https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1"
      title="${videoTitle.textContent.replace(/"/g, "&quot;")}"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowfullscreen
    ></iframe>
  `;
  videoModal.classList.add("is-open");
  videoModal.setAttribute("aria-hidden", "false");
  document.body.style.overflow = "hidden";
  videoClose?.focus();
};

initInlineVideoPlayers();

document.addEventListener("click", (event) => {
  const videoCard = event.target.closest?.("[data-video-card]");
  if (videoCard) {
    if (videoCard.closest("[data-video-player]")) return;
    openVideoModal(videoCard);
    return;
  }

  if (event.target === videoModal || event.target.closest?.("[data-video-close]")) {
    closeVideoModal();
  }
});

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape" && videoModal.classList.contains("is-open")) {
    closeVideoModal();
  }
});
